import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('transition', {
  root: {
    variants: {
      swoosh: ['left', 'right', 'top', 'bottom'],
      swooshExit: ['left', 'right', 'top', 'bottom'],
    },
  },
});
